module.exports = __webpack_public_path__ + "img/schnittkante_koenigsblau_farbnr543.cd0997e3.jpg";